
let formsMulti=[
    {
        path: '/multi1',
        name: 'multi1',
        component: () => import('@/views/formsMulti/multi1.vue')
    },
    {
        path: '/multi2',
        name: 'multi2',
        component: () => import('@/views/formsMulti/multi2.vue')
    },
    {
        path: '/multi3',
        name: 'multi3',
        component: () => import('@/views/formsMulti/multi3.vue')
    }]
export default formsMulti